export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';
export const API_URL = `${API_BASE}/api`;
